module.exports = __webpack_public_path__ + "img/maintenance_check.cac06857.svg";